import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { ITabBarConfig } from '@/shared/widgets/iframe-bridge';

interface IUiState {
  /**
   * Нижний таб-бар. `config === null` → дефолтные табы оболочки (Home/Services/Profile).
   * `config` задаёт сервис через мост (`ui.setTabBar`); `visible` — `ui.setTabBarVisible`.
   */
  tabBar: {
    visible: boolean;
    config: ITabBarConfig | null;
  };
}

const initialState: IUiState = {
  tabBar: {
    visible: true,
    config: null
  }
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setTabBarConfig: (state, action: PayloadAction<ITabBarConfig | null>) => {
      state.tabBar.config = action.payload;
      state.tabBar.visible = action.payload?.visible ?? true;
    },
    setTabBarVisible: (state, action: PayloadAction<boolean>) => {
      state.tabBar.visible = action.payload;
    },
    resetTabBar: (state) => {
      state.tabBar.config = null;
      state.tabBar.visible = true;
    }
  }
});

export const { setTabBarConfig, setTabBarVisible, resetTabBar } =
  uiSlice.actions;
export default uiSlice;
